import { Patient } from "../../../api/patient.types";
import { ResearchesViewAction } from "./researches.view.types";

export const researchesViewPatientSetAction = (patient: Patient): ResearchesViewAction => ({ type: 'RESEARCHES_VIEW_PATIENT_SET', params: patient })
export const researchesViewPatientClearAction = (): ResearchesViewAction => ({ type: 'RESEARCHES_VIEW_PATIENT_CLEAR' })